<template>
  <div class="invoice">
    <div class="invoice-header">
      <button class="remove-invoice" @click="removeInvoice()">&times;</button>
    </div>
    <div class="invoice-container">
      <div class="invoice-info">
        <div class="invoice-content">
          <label :for="getDynamicName('invoice-number')"
            >Número da nota fiscal</label
          >
          <input
            class="default-input"
            placeholder="(Apenas números)"
            :id="getDynamicName('invoice-number')"
            name="invoice-number"
            v-model="invoiceNumber"
            type="text"
          />
          <span class="error-text" v-if="isInvoiceNumberEmpty()"
            >*Nota fiscal inválida</span
          >
        </div>
        <div class="invoice-content">
          <label :for="getDynamicName('invoice-date')">Data da nota</label>
          <datepicker
            name="invoice-date"
            :id="getDynamicName('invoice-date')"
            placeholder="Data da nota"
            format="dd/MM/yyyy"
            input-class="datepicker"
            :language="ptBR"
            v-model="invoiceDate"
            :disabledDates="disabledDates"
          ></datepicker>
          <span class="error-text" v-if="!invoiceDate && hasErrors"
            >*Data inválida</span
          >
        </div>
      </div>
      <div class="items-quantity">
        <div class="items-quantity-content">
          <label :for="getDynamicName('amount-items')"
            >Quantidade de itens</label
          >
          <input
            class="default-input"
            name="items"
            :id="getDynamicName('amount-items')"
            v-model="itemsInstances"
            v-on:keyup.13="addItem()"
            type="text"
          />
        </div>
        <button @click="addItem()">Adicionar</button>
        <br />
      </div>
    </div>
    <Item
      v-for="(item, index) in itemsList"
      @deleteItem="removeItem(index)"
      @updateItem="updateItemStatus($event, item)"
      @updateItemData="updateItemData($event)"
      :selectItemsList="selectItemsList"
      :id="item.id"
      :invoiceIndex="id"
      :key="item.id"
      :isGettingItemData="isGettingItemData"
    />
  </div>
</template>

<script>
import { EventBus } from "@/eventHub";
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";
import Item from "@/components/home/return-solicitation/Item.vue";

export default {
  name: "invoice",
  components: {
    Datepicker,
    Item
  },
  data: function() {
    return {
      count: 0,
      ptBR,
      invoiceNumber: "",
      invoiceDate: "",
      itemsInstances: 1,
      itemsList: [],
      hasErrors: false,
      isGettingItemData: false,
      itemsDataList: [],
      disabledDates: {
        from: new Date()
      }
    };
  },
  watch: {
    invoiceNumber() {
      const regex = /^[0-9]+$/;
      if (this.invoiceNumber.match(regex)) {
      } else {
        this.invoiceNumber = this.invoiceNumber.substring(
          0,
          this.invoiceNumber.length - 1
        );
      }
    }
  },
  props: {
    id: Number,
    itemsAmount: Number,
    selectItemsList: Array
  },
  methods: {
    addItem() {
      if (this.itemsInstances <= 100 - this.itemsAmount) {
        let i = 0;
        while (i < this.itemsInstances) {
          this.itemsList.push({
            id: this.count,
            status: false
          });
          i++;
          this.count++;
          this.$emit("getCreatedItems");
        }
      }
      this.itemsInstances = 1;
    },
    removeInvoice() {
      this.$emit("deleteInvoice", this.itemsList.length);
    },
    maskInvoice(e) {
      const regex = /^[0-9]+$/;
      if (!e.key.match(regex) && e.key != "Backspace") {
        e.preventDefault();
      }
    },
    removeItem(index) {
      this.itemsList.splice(index, 1);
      this.$emit("getRemovedItems");
    },
    getDynamicName(name) {
      return `${name}-input-${this.id + 1}`;
    },
    updateItemStatus(status, item) {
      item.status = status;
    },
    haveAtLeastOneItemWithError() {
      return this.itemsList.find(item => {
        return item.status == false;
      });
    },
    areFieldsFilled() {
      return this.invoiceNumber && this.invoiceDate && this.itemsList.length;
    },
    updateInvoice() {
      this.$emit(
        "updateInvoice",
        !this.haveAtLeastOneItemWithError() && this.areFieldsFilled()
      );
    },
    isInvoiceNumberEmpty() {
      return !this.invoiceNumber && this.hasErrors;
    },
    updateItemData(item) {
      this.itemsDataList.push(item);
      if (this.itemsDataList.length === this.itemsList.length) {
        this.$emit("updateInvoiceData", {
          invoice: {
            invoice_number: this.invoiceNumber,
            invoice_date: this.invoiceDate
          },
          items: this.itemsDataList
        });
      }
    }
  },
  created() {
    EventBus.$on("sendClicked", () => {
      this.hasErrors = true;
      this.updateInvoice();
    });
    EventBus.$on("askInvoicesForData", () => {
      this.isGettingItemData = true;
    });
  },
  updated() {
    this.updateInvoice();
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/_colors.scss";

.invoice {
  margin-top: 30px;
  width: 53.75%;
  border-bottom: 1px solid $grey6;
  border-top: none;
  background-color: $grey5;
  padding-bottom: 13px;

  label {
    cursor: pointer;
    padding-bottom: 3px;
    white-space: nowrap;
  }
}

.invoice:last-child {
  margin-bottom: 30px;
}

.invoice-header {
  height: 30px;
  background-color: $grey1;
}

input {
  height: 25px;
  width: 300px;
  font-size: 14px;
  padding: 5px;
  border: 1px solid $grey3;

  &:focus {
    outline: none;
    border-color: $black;
  }
}

.invoice-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 13px 0 13px;
}

.items-quantity {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  .items-quantity-content {
    display: flex;
    flex-direction: column;
    width: 100%;

    & > input {
      height: 25px;
      width: 83%;
      font-size: 14px;
      padding: 5px;
      border: 1px solid $grey3;

      &:focus {
        outline: none;
        border-color: $black;
      }
    }
  }

  & > button {
    height: 37px;
    border: none;
    width: 170px;
    background-color: $orange1;
    color: $white;
    font-size: 14px;
    text-transform: uppercase;
    outline: none;
    cursor: pointer;

    &:hover {
      transition: 0.7s;
      background-color: $orange2;
    }
  }
}

.invoice-info {
  display: flex;

  .invoice-content {
    display: flex;
    flex-direction: column;

    & > input {
      height: 25px;
      width: 80%;
      font-size: 14px;
      padding: 5px;
      border: 1px solid $grey3;

      &:focus {
        outline: none;
        border-color: $black;
      }
    }
  }
}

.datepicker {
  position: relative;
  height: 37px;
  width: 55%;
  padding: 5px;
}

.remove-invoice {
  background: none;
  border: none;
  font-size: 34px;
  cursor: pointer;
  color: $white;
  padding: 0;
  position: relative;
  top: -6px;
  left: 96%;
  outline: none;

  &:hover {
    transition: 0.7s;
    outline: none;
    color: $orange1;
  }
}

.error-text {
  color: red;
  font-size: 15px;
}

@media only screen and (max-width: 1024px) {
  .invoice {
    width: 443px;
  }
}

@media only screen and (max-width: 1480px) {
  .invoice {
    font-size: 11px;
  }
}

@media only screen and (max-width: 1150px) {
  .invoice {
    font-size: 9px;

    button {
      width: 70px;
      font-size: 10px;
    }

    input,
    .default-input {
      font-size: 10px;
    }
  }
}
</style>
